export default __webpack_public_path__ + "static/lawyer-29c4368901792a2589511592baa21137.jpg";